import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import Color from 'color';

var deprecatedColorTokens = {
  /**
   * decorative--blue--50
   * --------------------
   *
   */
  'decorative--blue--50': Color.rgb([246, 247, 255]).toString(),
  /**
   * decorative--blue--100
   * ---------------------
   *
   */
  'decorative--blue--100': Color.rgb([237, 240, 255]).toString(),
  /**
   * decorative--blue--200
   * ---------------------
   *
   */
  'decorative--blue--200': Color.rgb([219, 225, 254]).toString(),
  /**
   * decorative--blue--300
   * ---------------------
   *
   */
  'decorative--blue--300': Color.rgb([164, 178, 252]).toString(),
  /**
   * decorative--blue--400
   * ---------------------
   *
   */
  'decorative--blue--400': Color.rgb([110, 133, 252]).toString(),
  /**
   * decorative--blue--500
   * ---------------------
   *
   */
  'decorative--blue--500': Color.rgb([74, 103, 251]).toString(),
  /**
   * decorative--blue--600
   * ---------------------
   *
   */
  'decorative--blue--600': Color.rgb([66, 85, 187]).toString(),
  /**
   * decorative--blue--700
   * ---------------------
   *
   */
  'decorative--blue--700': Color.rgb([43, 58, 136]).toString(),
  /**
   * decorative--purple--50
   * ----------------------
   *
   */
  'decorative--purple--50': Color.rgb([252, 245, 253]).toString(),
  /**
   * decorative--purple--100
   * -----------------------
   *
   */
  'decorative--purple--100': Color.rgb([250, 237, 252]).toString(),
  /**
   * decorative--purple--200
   * -----------------------
   *
   */
  'decorative--purple--200': Color.rgb([244, 218, 248]).toString(),
  /**
   * decorative--purple--300
   * -----------------------
   *
   */
  'decorative--purple--300': Color.rgb([227, 161, 236]).toString(),
  /**
   * decorative--purple--400
   * -----------------------
   *
   */
  'decorative--purple--400': Color.rgb([212, 106, 226]).toString(),
  /**
   * decorative--purple--500
   * -----------------------
   *
   */
  'decorative--purple--500': Color.rgb([201, 69, 219]).toString(),
  /**
   * decorative--purple--600
   * -----------------------
   *
   */
  'decorative--purple--600': Color.rgb([146, 63, 167]).toString(),
  /**
   * decorative--purple--700
   * -----------------------
   *
   */
  'decorative--purple--700': Color.rgb([100, 33, 117]).toString(),
  /**
   * decorative--pink--50
   * --------------------
   *
   */
  'decorative--pink--50': Color.rgb([255, 244, 248]).toString(),
  /**
   * decorative--pink--100
   * ---------------------
   *
   */
  'decorative--pink--100': Color.rgb([255, 234, 242]).toString(),
  /**
   * decorative--pink--200
   * ---------------------
   *
   */
  'decorative--pink--200': Color.rgb([254, 211, 227]).toString(),
  /**
   * decorative--pink--300
   * ---------------------
   *
   */
  'decorative--pink--300': Color.rgb([253, 145, 185]).toString(),
  /**
   * decorative--pink--400
   * ---------------------
   *
   */
  'decorative--pink--400': Color.rgb([253, 81, 144]).toString(),
  /**
   * decorative--pink--500
   * ---------------------
   *
   */
  'decorative--pink--500': Color.rgb([252, 37, 116]).toString(),
  /**
   * decorative--pink--600
   * ---------------------
   *
   */
  'decorative--pink--600': Color.rgb([193, 54, 112]).toString(),
  /**
   * decorative--pink--700
   * ---------------------
   *
   */
  'decorative--pink--700': Color.rgb([141, 30, 71]).toString(),
  /**
   * decorative--orange--50
   * ----------------------
   *
   */
  'decorative--orange--50': Color.rgb([255, 247, 243]).toString(),
  /**
   * decorative--orange--100
   * -----------------------
   *
   */
  'decorative--orange--100': Color.rgb([255, 240, 232]).toString(),
  /**
   * decorative--orange--200
   * -----------------------
   *
   */
  'decorative--orange--200': Color.rgb([255, 225, 209]).toString(),
  /**
   * decorative--orange--300
   * -----------------------
   *
   */
  'decorative--orange--300': Color.rgb([255, 179, 139]).toString(),
  /**
   * decorative--orange--400
   * -----------------------
   *
   */
  'decorative--orange--400': Color.rgb([255, 135, 70]).toString(),
  /**
   * decorative--orange--500
   * -----------------------
   *
   */
  'decorative--orange--500': Color.rgb([255, 105, 24]).toString(),
  /**
   * decorative--orange--700
   * -----------------------
   *
   */
  'decorative--orange--700': Color.rgb([174, 31, 0]).toString(),
  /**
   * decorative--orange--600
   * -----------------------
   *
   */
  'decorative--orange--600': Color.rgb([204, 81, 43]).toString(),
  /**
   * decorative--yellow--50
   * ----------------------
   *
   */
  'decorative--yellow--50': Color.rgb([255, 251, 242]).toString(),
  /**
   * decorative--yellow--100
   * -----------------------
   *
   */
  'decorative--yellow--100': Color.rgb([255, 249, 230]).toString(),
  /**
   * decorative--yellow--200
   * -----------------------
   *
   */
  'decorative--yellow--200': Color.rgb([255, 241, 204]).toString(),
  /**
   * decorative--yellow--300
   * -----------------------
   *
   */
  'decorative--yellow--300': Color.rgb([255, 220, 127]).toString(),
  /**
   * decorative--yellow--400
   * -----------------------
   *
   */
  'decorative--yellow--400': Color.rgb([255, 201, 51]).toString(),
  /**
   * decorative--yellow--500
   * -----------------------
   *
   */
  'decorative--yellow--500': Color.rgb([255, 187, 0]).toString(),
  /**
   * decorative--yellow--600
   * -----------------------
   *
   */
  'decorative--yellow--600': Color.rgb([235, 155, 0]).toString(),
  /**
   * decorative--yellow--700
   * -----------------------
   *
   */
  'decorative--yellow--700': Color.rgb([210, 114, 0]).toString(),
  /**
   * decorative--red--50
   * -------------------
   *
   */
  'decorative--red--50': Color.rgb([253, 243, 245]).toString(),
  /**
   * decorative--red--100
   * --------------------
   *
   */
  'decorative--red--100': Color.rgb([251, 233, 237]).toString(),
  /**
   * decorative--red--200
   * --------------------
   *
   */
  'decorative--red--200': Color.rgb([253, 206, 214]).toString(),
  /**
   * decorative--red--300
   * --------------------
   *
   */
  'decorative--red--300': Color.rgb([248, 170, 185]).toString(),
  /**
   * decorative--red--400
   * --------------------
   *
   */
  'decorative--red--400': Color.rgb([244, 113, 139]).toString(),
  /**
   * decorative--red--500
   * --------------------
   *
   */
  'decorative--red--500': Color.rgb([213, 26, 70]).toString(),
  /**
   * decorative--red--600
   * --------------------
   *
   */
  'decorative--red--600': Color.rgb([179, 5, 57]).toString(),
  /**
   * decorative--red--700
   * --------------------
   *
   */
  'decorative--red--700': Color.rgb([139, 4, 47]).toString(),
  /**
   * decorative--green--50
   * ---------------------
   *
   */
  'decorative--green--50': Color.rgb([242, 250, 244]).toString(),
  /**
   * decorative--green--100
   * ----------------------
   *
   */
  'decorative--green--100': Color.rgb([233, 248, 237]).toString(),
  /**
   * decorative--green--200
   * ----------------------
   *
   */
  'decorative--green--200': Color.rgb([217, 241, 223]).toString(),
  /**
   * decorative--green--300
   * ----------------------
   *
   */
  'decorative--green--300': Color.rgb([159, 226, 172]).toString(),
  /**
   * decorative--green--400
   * ----------------------
   *
   */
  'decorative--green--400': Color.rgb([106, 206, 125]).toString(),
  /**
   * decorative--green--500
   * ----------------------
   *
   */
  'decorative--green--500': Color.rgb([54, 155, 74]).toString(),
  /**
   * decorative--green--600
   * ----------------------
   *
   */
  'decorative--green--600': Color.rgb([37, 123, 61]).toString(),
  /**
   * decorative--green--700
   * ----------------------
   *
   */
  'decorative--green--700': Color.rgb([26, 91, 48]).toString(),
  /**
   * decorative--grayscale--white
   * ----------------------------
   *
   */
  'decorative--grayscale--white': Color.rgb([255, 255, 255]).toString(),
  /**
   * decorative--grayscale--100
   * --------------------------
   *
   */
  'decorative--grayscale--100': Color.rgb([250, 250, 250]).toString(),
  /**
   * decorative--grayscale--200
   * --------------------------
   *
   */
  'decorative--grayscale--200': Color.rgb([245, 245, 245]).toString(),
  /**
   * decorative--grayscale--300
   * --------------------------
   *
   */
  'decorative--grayscale--300': Color.rgb([232, 232, 232]).toString(),
  /**
   * decorative--grayscale--400
   * --------------------------
   *
   */
  'decorative--grayscale--400': Color.rgb([217, 217, 217]).toString(),
  /**
   * decorative--grayscale--500
   * --------------------------
   *
   */
  'decorative--grayscale--500': Color.rgb([191, 191, 191]).toString(),
  /**
   * decorative--grayscale--600
   * --------------------------
   *
   */
  'decorative--grayscale--600': Color.rgb([140, 140, 140]).toString(),
  /**
   * decorative--grayscale--700
   * --------------------------
   *
   */
  'decorative--grayscale--700': Color.rgb([89, 89, 89]).toString(),
  /**
   * decorative--grayscale--800
   * --------------------------
   *
   */
  'decorative--grayscale--800': Color.rgb([64, 64, 64]).toString(),
  /**
   * decorative--grayscale--900
   * --------------------------
   *
   */
  'decorative--grayscale--900': Color.rgb([51, 51, 51]).toString(),
  /**
   * decorative--grayscale--1000
   * ---------------------------
   *
   */
  'decorative--grayscale--1000': Color.rgb([38, 38, 38]).toString(),
  /**
   * decorative--grayscale--black
   * ----------------------------
   *
   */
  'decorative--grayscale--black': Color.rgb([0, 0, 0]).toString(),
  /**
   * decorative--lightBlue--50
   * -------------------------
   *
   */
  'decorative--lightBlue--50': Color.rgb([244, 253, 254]).toString(),
  /**
   * decorative--lightBlue--100
   * --------------------------
   *
   */
  'decorative--lightBlue--100': Color.rgb([234, 252, 254]).toString(),
  /**
   * decorative--lightBlue--200
   * --------------------------
   *
   */
  'decorative--lightBlue--200': Color.rgb([211, 247, 251]).toString(),
  /**
   * decorative--lightBlue--300
   * --------------------------
   *
   */
  'decorative--lightBlue--300': Color.rgb([145, 235, 245]).toString(),
  /**
   * decorative--lightBlue--400
   * --------------------------
   *
   */
  'decorative--lightBlue--400': Color.rgb([80, 224, 241]).toString(),
  /**
   * decorative--lightBlue--500
   * --------------------------
   *
   */
  'decorative--lightBlue--500': Color.rgb([36, 216, 237]).toString(),
  /**
   * decorative--lightBlue--600
   * --------------------------
   *
   */
  'decorative--lightBlue--600': Color.rgb([26, 163, 193]).toString(),
  /**
   * decorative--lightBlue--700
   * --------------------------
   *
   */
  'decorative--lightBlue--700': Color.rgb([15, 109, 138]).toString()
};
var deprecatedGradientTokens = {
  /**
   * decorative--gradient--dusk
   * --------------------------
   *
   */
  'decorative--gradient--dusk': {
    rotation: 45,
    stops: [{
      position: 0,
      value: Color.rgb([35, 216, 237]).toString()
    }, {
      position: 100,
      value: Color.rgb([73, 103, 251]).toString()
    }]
  },
  /**
   * decorative--gradient--midnight-blue
   * -----------------------------------
   *
   */
  'decorative--gradient--midnight-blue': {
    rotation: 45,
    stops: [{
      position: 0,
      value: Color.rgb([200, 68, 219]).toString()
    }, {
      position: 100,
      value: Color.rgb([73, 103, 251]).toString()
    }]
  },
  /**
   * decorative--gradient--dawn
   * --------------------------
   *
   */
  'decorative--gradient--dawn': {
    rotation: 45,
    stops: [{
      position: 0,
      value: Color.rgb([200, 68, 219]).toString()
    }, {
      position: 100,
      value: Color.rgb([251, 36, 116]).toString()
    }]
  },
  /**
   * decorative--gradient--sunset
   * ----------------------------
   *
   */
  'decorative--gradient--sunset': {
    rotation: 45,
    stops: [{
      position: 0,
      value: Color.rgb([251, 36, 116]).toString()
    }, {
      position: 100,
      value: Color.rgb([255, 105, 23]).toString()
    }]
  },
  /**
   * decorative--gradient--sunrise
   * -----------------------------
   *
   */
  'decorative--gradient--sunrise': {
    rotation: 45,
    stops: [{
      position: 0,
      value: Color.rgb([255, 105, 23]).toString()
    }, {
      position: 100,
      value: Color.rgb([255, 187, 0]).toString()
    }]
  }
};

export { deprecatedColorTokens, deprecatedGradientTokens };
